export default __webpack_public_path__ + "static/media/ .07617dcd.webp";